import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/materials?accountID=${accountID}`
      }))
  );
}

async function getById(materialID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/materials/${materialID}`
      }))
  );
}

async function create(material) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/materials',
        body: JSON.stringify(material)
      }))
  );
}

async function createMultiple(materials) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/materials/bulk',
        body: JSON.stringify(materials)
      }))
  );
}

async function update(material) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/materials/${material.materialID}`,
        body: JSON.stringify(material)
      }))
  );
}

async function getParentMaterials(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/materials/parents/${accountID}`
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(materialID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/materials/${materialID}`
      }))
  );
}

const materialService = {
  getAll,
  getById,
  getParentMaterials,
  create,
  createMultiple,
  update,
  delete: Delete
};

export default materialService;
